import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import axios from 'axios'

// The second argument is optional and sets the default config values for every player.
Vue.prototype.$http = axios


Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  Plyr,
  render: h => h(App)
}).$mount('#app')
